import React from 'react';
import UpcomingShipments from '../../../views/practice/shipments/UpcomingShipments';
import BackorderedItems from '../../../views/practice/shipments/BackorderedItems';
import ShipmentsWrapper from '../../../views/practice/shipments/ShipmentsWrapper';
import ShipmentHistory from '../../../views/practice/shipments/shipmenthistory/ShipmentHistory';
import PendingApprovals from '../../../views/practice/shipments/pendingapprovals/PendingApprovals';

const shipmentRoutes = [
  {
    path: 'practice/shipments',
    element: <ShipmentsWrapper />,
    children: [
      {
        path: 'upcoming',
        element: <UpcomingShipments />
      },
      {
        path: 'pending/:kitId?',
        element: <PendingApprovals />
      },
      {
        path: 'backorders',
        element: <BackorderedItems />
      },
      {
        path: 'history',
        element: <ShipmentHistory />
      }
    ]
  }
];

export default shipmentRoutes;
